// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const HIW_REQUEST_PAGE_DATA = 'HIW_REQUEST_PAGE_DATA';
const HIW_REQUEST_PAGE_DATA_SUCCESS = 'HIW_REQUEST_PAGE_DATA_SUCCESS';

export {
  HIW_REQUEST_PAGE_DATA,
  HIW_REQUEST_PAGE_DATA_SUCCESS,
};
